/**
 * Items used to generate the key used for the entity-info page
 * state, with campaignId and entityId
 */
export interface EntityInfoPageKeyParams {
  campaignId: string;
  entityId: string;
}

export const toEntityInfoPageKey = (
  params: EntityInfoPageKeyParams
) => `entityId:${params.entityId}-campaignId:${params.campaignId}`;
